<template>
    <div class="common-table-wrapper" :class="{ 'no-border': noBorder }" :style="wrapperStyle">
        <table class="common-table" :class="tableClass">
            <thead>
                <slot name="header">
                    <tr>
                        <slot name="header-cells"></slot>
                    </tr>
                </slot>
            </thead>
            <tbody>
                <slot name="body"></slot>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "CommonTable",
    props: {
        // Wrapper 스타일 제어
        width: {
            type: String,
            default: "98%",
        },
        maxHeight: {
            type: String,
            default: null,
        },
        margin: {
            type: String,
            default: "12px",
        },
        // 테이블 클래스
        tableClass: {
            type: String,
            default: "",
        },
        // 커스텀 스타일
        customStyle: {
            type: Object,
            default: () => ({}),
        },
        // border 제거 옵션 (wrapper에 border가 있는 경우)
        noBorder: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        wrapperStyle() {
            const style = {
                width: this.width,
                margin: this.margin,
                maxHeight: this.maxHeight,
                ...this.customStyle,
            };

            // no-border일 때 maxHeight가 있으면 스크롤 활성화
            if (this.noBorder && this.maxHeight) {
                style.overflowY = "auto";
            }

            return style;
        },
    },
};
</script>

<style scoped>
.common-table-wrapper {
    background: #ffffff;
    position: relative;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    overflow-y: auto;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.common-table-wrapper.no-border {
    border: none;
    border-radius: 0;
    box-shadow: none;
    position: relative;
    overflow: visible;
}

.common-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: #ffffff;
    font-size: 12.5px;
    color: #0f172a;
}

.common-table thead {
    background: #f8fafc;
    position: sticky;
    top: 0;
    z-index: 10;
    box-shadow: 0 1px 0 rgba(148, 163, 184, 0.25);
}

.common-table th {
    padding: 8px 12px;
    text-align: center;
    font-weight: 700;
    font-size: 11px;
    color: #334155;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
}

.common-table tbody {
    background: #ffffff;
}

.common-table tbody tr:first-child {
    border-top: none;
}

.common-table tbody tr {
    border-bottom: 1px solid #edf2f7;
    transition:
        background-color 0.15s ease,
        box-shadow 0.15s ease;
    background: #ffffff;
}

.common-table tbody tr:nth-child(even) {
    background: #fbfcfe;
}

.common-table tbody tr:hover {
    background: #f6f8fb;
}

.common-table tbody tr.clickable-row {
    cursor: pointer;
}

.common-table tbody tr.is-active {
    background: #eef2f6;
    box-shadow: inset 3px 0 0 #52b788;
}

.common-table tbody tr.is-active:hover {
    background: #e9eef3;
}

.common-table tbody tr:last-child {
    border-bottom: none;
}

.common-table td {
    padding: 8px 12px;
    vertical-align: middle;
    text-align: center;
    color: #1f2937;
    font-weight: 500;
    font-size: 12px;
}
</style>
